import allBrands from "../assets/branding/brands-full.svg";
import alseaLogo from "../assets/branding/logos/alsea-white.svg";
import woeLogo from "../assets/branding/logos/woe.svg";
import settingsIcon from "../assets/branding/icon-administracion.svg";
import calendarIcon from "../assets/branding/icon-calendar.svg";
import reportIcon from "../assets/branding/icon-reportes.svg";

export const BRANDINGS_ICONS = {
  allBrands,
  alseaLogo,
  woeLogo,
  settingsIcon,
  calendarIcon,
  reportIcon,
};
